export default "__VITE_ASSET__D620_rRH__"